var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Coz-device-software-setting-play-greeting-item\u003E\u003C\u002Foz-device-software-setting-play-greeting-item\u003E";;return pug_html;};
module.exports = template;